import React, { useState, useEffect } from "react";
import { connect } from 'react-redux'
import { makeStyles } from "@material-ui/styles";
import { Table,TableRow, TableCell, Typography, Button, IconButton, Card } from "@mui/material";
import { CircularProgress } from "@material-ui/core";
// import * as Action from "../../actions/adminAction"
// import Image1 from "../../Assets/Image/satara_Mandave.JPG"
// import Image2 from "../../Assets/Image/satara_Mandave_2.jpg"
import { useLocation, useNavigate } from "react-router-dom";
// import Stack from "@mui/material/Stack";
// import CloseIcon from "@mui/icons-material/Close";
import dayjs from "dayjs";
import { BASE_URL } from "../../utils/urls";
require('../../App.css')


export const RolloutDetailsDC = ({ userDetails }) => {

    const classes = useStyles()
    const navigate = useNavigate()
    const location = useLocation()
    const Trainer = location.state
    const [gramData, setGramData] = useState();
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getGramData()

    }, [])
    
    const getGramData = () => {
        setLoader(true);
        const url = BASE_URL + "/location/gettrainingLocationsinglelist";
        let header = new Headers();
        header.append("Content-Type", "application/x-www-form-urlencoded")
        let urlencoded = new URLSearchParams();
        urlencoded.append("grampanchayat_id", Trainer?.grampanchayat_id);
        const opt = {
            method: 'POST',
            headers: header,
            body: urlencoded,
        }
        fetch(url, opt)
            .then(res => {
                if (res.status === 200) {
                    return res.json();
                }
                else {
                    alert("Error While Getting Training Location Data");
                }
            })
            .then(data => {
                // console.log("GramData,", data)
                data !== undefined && data !== null && data !== "No data found" && setGramData(data)
                setLoader(false);
            })
            .catch(err => { alert("Error catched While getting Gram Data");  })
    }

    const [openModal, setOpenModal] = useState(false);

    // console.log("Data", Trainer)
    // console.log("Details", userDetails)

    if (loader)
        return (<div className={classes.main}>
            <CircularProgress color="success" />
        </div>)

    return (
        <div className={classes.main}>
            <Card className={classes.card} style={{ backgroundColor: 'whitesmoke' }}>
                <div style={{ backgroundColor: '#3A3A56', display: 'flex', flexDirection: 'row', width: '100%', margin: 0 }}>
                    <IconButton style={{ margin: 10, padding: 0 }}>
                        <Typography style={{ fontFamily: 'sans-serif', fontWeight: 700, color: 'white', fontSize: 24, backgroundColor: '#3A3A56' }} sx={{
                        }} >Plan Details</Typography>
                    </IconButton>
                </div>
                <div>
                    <Table>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Training Date:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? dayjs(Trainer.startDate,).format("DD/MM/YYYY") : '-'}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>District:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.districtName : "-"}</TableCell>
                            {/* <TableCell style={{ fontSize: 20 }}>J.K. &#40;8893489833&#41;</TableCell> */}
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Training Location:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.grampanchayatName : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Module:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainingModuleName : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Batch:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer?.batch? Trainer?.batch?.toUpperCase():'-' : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Trainer1:</TableCell>
                            {/* {// console.log("MyTrainer",Trainer)} */}
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainerNameAll[0]: "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Trainer1 Mobile:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainerMobileAll[0]: "-"}</TableCell>
                            {/* <TableCell style={{ fontSize: 20 }}>{Trainer!==undefined && Trainer!==null ? Trainer.grampanchayatName:"-"}</TableCell> */}
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Trainer2:</TableCell>
                            {/* {// console.log("MyTrainer",Trainer)} */}
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainerNameAll[1]: "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Trainer2 Mobile:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{Trainer !== undefined && Trainer !== null ? Trainer.trainerMobileAll[1]: "-"}</TableCell>
                            {/* <TableCell style={{ fontSize: 20 }}>{Trainer!==undefined && Trainer!==null ? Trainer.grampanchayatName:"-"}</TableCell> */}
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>District Co-Ordinator:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>-</TableCell>
                            {/* <TableCell style={{ fontSize: 20 }}>J.K. &#40;8893489833&#41;</TableCell> */}
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Sarpanch Name:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{gramData !== undefined && gramData.length > 0 && gramData[0]?.sarpanchName !== 'null' && gramData[0]?.sarpanchName !== null ? gramData[0]?.sarpanchName : "-"}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell style={{ fontSize: 20 }}>Gram Sevak Name:</TableCell>
                            <TableCell style={{ fontSize: 20 }}>{gramData !== undefined && gramData.length > 0 && gramData[0]?.gramsevakhName !== 'null' && gramData[0]?.gramsevakhName !== null ? gramData[0]?.gramsevakhName : "-"}</TableCell>
                        </TableRow>
                    </Table>
                </div>
                <center>
                    <Button variant="contained" style={{ margin: 20 }} onClick={() => navigate(-1)}>Back</Button>
                </center>
            </Card>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({
    main: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: 'column',
        marginTop: 30
    },
    card: {
        width: '100%',
        borderRadius: '20px !important',
        margin: '20px',
        padding: '20px',
    },
    passmodal: {
        width: '350px',
        background: 'white',
        borderRadius: '20px !important',
        margin: '20px',
        padding: '20px',
    },
    profilemodal: {
        width: '1000px',
        background: 'white',
        borderRadius: '20px !important',
        margin: '20px',
        padding: '20px',
    },
    middlePosition: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
    },
    input: {
        width: '70%',
        background: 'white',
        marginTop: '20px',
        padding: '5px 15px'
    },
    image: {
        width: 150,
        height: 150
    },
    imageApprove: {
        backgroundColor: 'green',
        color: 'white'
    },
    imageReject: {
        backgroundColor: 'red',
        color: 'white'
    }
}));

const mapStateToProps = (state) => {
    return {
        userDetails: state.auth.userDetails,
    }
}

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(RolloutDetailsDC)